import { useRef, useState } from 'react';
import { LuMinus, LuPlus } from 'react-icons/lu';
import {
  keepSectionTopDuringExpand,
  scrollSectionAfterCollapse,
} from '../../../utils/scrollAfterCollapse';
import HomeSectionAccordion from '../HomeSectionAccordion/HomeSectionAccordion';
import './style.css';

const faqItems = [
  {
    id: 'laser-scanning',
    question: 'Вы выполняете лазерное сканирование?',
    answer: [
      'Нет. DotPolyline не выполняет сканирование на объекте. Мы работаем с готовыми облаками точек, полученными и предоставленными клиентом.',
    ],
  },
  {
    id: 'cost-estimate-data',
    question: 'Что нужно предоставить для расчёта стоимости?',
    answer: [
      'Для предварительной оценки понадобятся облако точек или его образец, краткое описание объекта, перечень необходимых материалов, требуемые форматы, уровень детализации и желаемый срок.',
      'Если требования ещё не определены, достаточно прислать ссылку на данные и кратко описать задачу — мы поможем уточнить состав работ.',
    ],
  },
  {
    id: 'drawing-model-accuracy',
    question: 'Насколько точными будут чертежи и BIM-модели?',
    answer: [
      'Точность зависит от качества, плотности и точности регистрации исходного облака точек. До начала работы мы согласовываем требования к точности и уровню детализации.',
      'Участки, которые невозможно достоверно определить из-за шумов, пропусков или недостаточной видимости, отмечаются и согласовываются с клиентом.',
    ],
  },
  {
    id: 'client-standards',
    question: 'Можете ли вы работать по нашим CAD- или BIM-стандартам?',
    answer: [
      'Да. Мы можем использовать ваши шаблоны, структуру слоёв, правила наименования, семейства Revit, стандарты оформления и примеры готовой документации. Их необходимо предоставить до начала работы.',
    ],
  },
  {
    id: 'cost-and-timeline',
    question: 'От чего зависят стоимость и срок выполнения?',
    answer: [
      'Стоимость и срок зависят от площади и сложности объекта, качества облака точек, состава документации, требуемой детализации, стандартов клиента и срочности проекта.',
      'После изучения исходных данных мы предоставляем согласованный объём работ, стоимость и плановый срок выполнения.',
    ],
  },
];

const FAQSection = () => {
  const [openItemId, setOpenItemId] = useState(null);
  const itemRefs = useRef({});

  const toggleItem = itemId => {
    if (openItemId === itemId) {
      scrollSectionAfterCollapse(itemRefs.current[itemId]);
    } else {
      keepSectionTopDuringExpand(itemRefs.current[itemId]);
    }

    setOpenItemId(currentId => (currentId === itemId ? null : itemId));
  };

  return (
    <section
      className="section faq-section"
      id="faq"
      aria-labelledby="home-faq-heading"
    >
      <div className="container">
        <div className="faq-section__wrapper">
          <HomeSectionAccordion
            id="faq"
            title="Часто задаваемые вопросы"
            summary="Краткие ответы о подготовке данных, точности, стандартах, стоимости и сроках работы."
            summaryClassName="faq-section__description"
            summaryContainerClassName="faq-section__intro"
          >
            <div className="faq-section__list">
              {faqItems.map(({ answer, id, question }) => {
                const isOpen = openItemId === id;
                const buttonId = `faq-${id}-button`;
                const panelId = `faq-${id}-panel`;

                return (
                  <article
                    className={`faq-section__item${isOpen ? ' is-open' : ''}`}
                    key={id}
                    ref={element => {
                      itemRefs.current[id] = element;
                    }}
                  >
                    <h2 className="faq-section__question-heading">
                      <button
                        type="button"
                        className="faq-section__toggle"
                        id={buttonId}
                        aria-expanded={isOpen}
                        aria-controls={panelId}
                        onClick={() => toggleItem(id)}
                        onKeyDown={event => {
                          if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            toggleItem(id);
                          }
                        }}
                      >
                        <span className="faq-section__question">{question}</span>
                        <span className="faq-section__icon" aria-hidden="true">
                          <LuPlus className="faq-section__icon-plus" />
                          <LuMinus className="faq-section__icon-minus" />
                        </span>
                      </button>
                    </h2>

                    <div
                      className="faq-section__panel"
                      id={panelId}
                      role="region"
                      aria-labelledby={buttonId}
                      aria-hidden={!isOpen}
                    >
                      <div className="faq-section__panel-inner">
                        <div className="faq-section__answer">
                          {answer.map(paragraph => (
                            <p key={paragraph}>{paragraph}</p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </HomeSectionAccordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
